<template>
  <div class="drawer" v-if="currentUser">
    <div class="user-avatar">
      <div class="avatar-details">
        <h5>{{ currentUser.Username }}</h5>
        <p>{{ currentUser.Type }}</p>
      </div>
    </div>
    <div class="routes">
      <ul>
        <li>
          <router-link @click.native="back" :to="{ name: 'view-requests' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="unlock-keyhole" />
            </div>
            Override Requests
          </router-link>
        </li>

        <li>
          <a @click="userLogout">
            <div class="icon-box text-danger">
              <font-awesome-icon class="icon" icon="lock" />
            </div>
            User Logout
          </a>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
import * as Sentry from '@sentry/vue';
import {Storage} from '@/services/Storage';
export default {
  name: "NavigationDrawer",

  computed : {
    currentUser() {
      return this.$store.getters.getCurrentUser
    },
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  beforeMount() {
    this.validateLogin();
  },
  methods: {
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined")
      }
    },
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
    async validateLogin() {
      let user = await Storage.getCurrentUser();
      let isLoggedIn = !!user;
      if (isLoggedIn) this.$store.commit('setCurrentUser', user);
      if (!isLoggedIn) {
        return this.$router.push({name: 'user-login'})
      }
    },
    userLogout(){
      return Swal.fire({
        title: "Are you sure?",
        text: "You will be logged out!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Logout!"
      }).then((result) => {
        if (result.isConfirmed) {
          // Clear the user context from Sentry so events captured after
          // logout are not attributed to the previous user. Called before
          // the router push so the call still has the previous user context.
          Sentry.setUser(null);
          return this.$router.push({ name : `user-login` })
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .routes {
    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        padding: 0;

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 600;
          padding-left: 10px;
          text-decoration: none;
          color: #1c1c1c;

          .icon-box {
            width: 35px;
            margin-right: 10px;
            display: flex;
            justify-content: center;

            .icon {
              font-size: 25px;
              color: #34373C;
            }
          }

          &:hover,
          &.router-link-exact-active {
            background: #f1f1f1;
            color: #3a71e8;
            //218efd 3a71e8
            font-weight: 700;

            .icon-box {
              .icon {
                color: #3a71e8;
              }
            }
          }
        }
      }
    }
  }

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/play-banner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: #1f2937;
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5,
      p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #ffffff;
          font-weight: 600;
        }
      }

    }
  }
}

ul {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}
</style>
